import ReportFooter from "../ReportFooter/ReportFooter";
import Input from "../Input/Input";
import Label from "../Label/Label";
import React from "react";
import Logo from "./../../assets/images/Logo.png";
import { API_ENDPOINT, ROOT_URI, FIRST_PAGE_IMAGE_PRIORITY } from "../../constants/constants";
import DynamicTextArea from "../DynamicTextArea/DynamicTextArea";
import "./firstpage.css";
import { useState, useRef } from "react";

const FirstPage = ({
  onFindingsChange,
  report,
  handleChange,
  handleArrayChange,
  totalPages,
  userId,
  onReportDetailsChange,
  signatureUrl, // signature image/url
  signatureEnabled = true, // whether to show prepared-by/signature overlay
  handleTableChange,
}) => {
  console.log("doctor details!!!!!!!!!!!!!!!!!", report);
  const [findings, setFindings] = useState(report.findings || "");

  // Sync findings state with report.findings when it changes
  React.useEffect(() => {
    setFindings(report.findings || "");
  }, [report.findings]);
  const [pacemaker, setPacemaker] = useState(false);
  const buildPausesInExcessValue = (reportData) => {
    // Return the raw value, no formatting
    return reportData?.pausesInExcess || "";
  };

  const [formData, setFormData] = useState({
    name: report.name || "",
    patientid: report.device_id || "",
    Indication: report.indication || "",
    gender: report.gender || "",
    age: report.age || "",
    duration: report.duration || "",
    organization: (report.hospital || "")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" "),
    referredBy: report.doctorName || "",
    from: report.from || "",
    to: report.to || "",
    beats: report.total_beatscount || "",
    mrd_no: report.ip_op || "",
    pacemaker: report.hyper_lipidemia || false,
    atrial_ectopicsTotal: report.pac[0] || "",
    atrial_ectopicsIsolated: report.pac[4] || "",
    atrial_ectopicsCouplet: report.pac[5] || "",
    atrial_ectopicsTriplet: report.pac[6] || "", // Triplet value
    atrial_ectopicsLongest: report.pac[12] || "",
    atrial_ectopicsFastest: report.pac[13] || "",
    atrial_ectopicsTrigeminy: report.pac[10] || "",
    atrial_ectopicsBigeminy: report.pac[11] || "",
    ventricular_ectopicsTotal: report.pvc[0] || "",
    ventricular_ectopicsIsolated: report.pvc[4] || "",
    ventricular_ectopicsCouplet: report.pvc[5] || "",
    ventricular_ectopicsTriplet: report.pvc[6] || "", // Triplet value
    ventricular_ectopicsLongest: report.pvc[12] || "",
    ventricular_ectopicsFastest: report.pvc[13] || "",
    ventricular_ectopicsTrigeminy: report.pvc[10] || "",
    ventricular_ectopicsBigeminy: report.pvc[11] || "",
    ventricular_ectopicsEpisodes: report.vt[5] || "",
    pausesInExcess: buildPausesInExcessValue(report),
    pausesIntwosec: report.pausesIntwosec || "",
    maxPause: report.maxPause || "",
    maxPauseFull: report.maxPause || "",
    sinus_pause: report.sinus_pause || "",
    longest_rr: report.longest_rr || [],
    showDropdown: false,
    afibBurden: report.afib[0] || "",
    afibLongest: report.afib[6] || "",
    afibFastest: report.afib[7] || "",
  });

  React.useEffect(() => {
    console.log("📊 Report data updated:", report?.longest_rr);
    
    if (report?.longest_rr && Array.isArray(report.longest_rr)) {
      setFormData(prev => ({
        ...prev,
        longest_rr: report.longest_rr
      }));
    }

    if (report?.sinus_pause) {
      const parts = report.sinus_pause.split(",");
      const longestRR = parts[8]?.trim() || "";
      const displayValue = buildLongestRRDisplayValue(longestRR);

      setFormData(prev => ({
        ...prev,
        maxPause: displayValue,
        maxPauseFull: longestRR
      }));
    }

    const pausesInExcessValue = buildPausesInExcessValue(report);
    if (pausesInExcessValue !== undefined) {
      setFormData(prev => ({
        ...prev,
        pausesInExcess: pausesInExcessValue
      }));
    }
  }, [report?.longest_rr, report?.sinus_pause, report?.["sinus pause 3 sec"], report?.pausesInExcess]);

  const extractTimeFromLongestRR = (value = "") => {
    const timeMatch = value.match(/(\d{2}:\d{2}:\d{2})/);
    return timeMatch ? timeMatch[1] : value.trim();
  };

  const extractDateFromLongestRR = (value = "") => {
    const dateMatch = value.match(/(\d{4}-\d{2}-\d{2})/);
    if (dateMatch) return dateMatch[1];
    const altDateMatch = value.match(/(\d{2}-\d{2}-\d{4})/);
    return altDateMatch ? altDateMatch[1] : "";
  };

  const buildLongestRRDisplayValue = (value = "") => {
    if (!value) return "";
    const parts = value.split("@");
    if (parts.length < 2) return value.trim();
    const sec = parts[0].trim();
    const timePart = parts.slice(1).join("@").trim();
    const timeOnly = extractTimeFromLongestRR(timePart);
    return timeOnly ? `${sec} @ ${timeOnly}` : `${sec} @ ${timePart}`;
  };

  const buildLongestRRFullValueFromItem = (item) => {
    if (!item) return "";
    const rawTime = item.time || "";
    const timeOnly = extractTimeFromLongestRR(rawTime);
    const dateOnly = extractDateFromLongestRR(rawTime);
    const dateTime = dateOnly
      ? `${dateOnly} ${timeOnly || rawTime}`.trim()
      : (timeOnly || rawTime).trim();
    return `${item.rr_sec} sec @ ${dateTime}`.trim();
  };

  const buildLongestRROptionLabel = (item) => {
    const fullValue = buildLongestRRFullValueFromItem(item);
    const timePart = fullValue.split("@")[1]?.trim() || "";
    const hrPart = item?.hr ? ` (HR ${item.hr})` : "";
    return `${item.rr_sec} sec @ ${timePart}${hrPart}`.trim();
  };

  // Helper function to update findings with new longest RR value
  const updateFindingsWithLongestRR = (rrValue) => {
    if (!report?.findings && !findings) return;
    if (!rrValue) return;

    const parts = rrValue.split("@").map(v => v.trim());
    if (parts.length !== 2) return;

    const [sec, time] = parts;
    let cleanTime = time.replace(/\.*$/, "").trim();
    if (time.match(/\d\.$/)) {
      cleanTime = time;
    }
    const newSentence = `Longest RR interval noted was ${sec} on ${cleanTime}.`;

    // Split findings into lines
    let lines = (findings || report.findings || "").split('\n');
    let replaced = false;
    lines = lines.map(line => {
      // Replace any line containing 'Longest RR interval noted' (case-insensitive)
      if (/longest rr interval noted/i.test(line)) {
        replaced = true;
        return `# ${newSentence}`;
      }
      return line;
    });
    if (!replaced) {
      // Insert after first line if not present
      if (lines.length > 0) {
        lines.splice(1, 0, `# ${newSentence}`);
      } else {
        lines.push(`# ${newSentence}`);
      }
    }
    const updatedFindings = lines.filter(line => line).join('\n');
    setFindings(updatedFindings);
    if (onFindingsChange) {
      onFindingsChange(updatedFindings);
    }
    if (handleChange) {
      handleChange({ target: { name: 'findings', value: updatedFindings } });
    }
  };




  // console.log(report)
  console.log("report!!!!!", report.hyper_lipidemia);
  console.log("pacemakerr!!!!!!!!!!!!!!!!!!!!!!!!", formData);

  // Draggable signature state
  const [sigPos, setSigPos] = useState({ x: 30, y: 600 }); // default position: left side
  const [dragging, setDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0); // rotation in degrees
  const [showRotate, setShowRotate] = useState(false);
  const pageRef = useRef(null);

  // Mouse event handlers for dragging
  const handleMouseDown = (e) => {
    if (e.button !== 0) return; // Only left click
    setDragging(true);
    const rect = pageRef.current.getBoundingClientRect();
    setOffset({
      x: e.clientX - rect.left - sigPos.x,
      y: e.clientY - rect.top - sigPos.y,
    });
    e.stopPropagation();
    e.preventDefault();
  };
  const handleMouseMove = (e) => {
    if (!dragging) return;
    const rect = pageRef.current.getBoundingClientRect();
    setSigPos({
      x: e.clientX - rect.left - offset.x,
      y: e.clientY - rect.top - offset.y,
    });
    e.stopPropagation();
    e.preventDefault();
  };
  const handleMouseUp = () => {
    setDragging(false);
  };

  // Attach/detach mousemove/up listeners
  React.useEffect(() => {
    if (dragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    } else {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [dragging, offset]);

  // Add a handler to rotate the signature
  const handleRotateSignature = () => {
    setRotation((prev) => (prev + 15) % 360);
  };

  // Show/hide rotate button when clicking the image
  const handleSignatureClick = (e) => {
    setShowRotate((prev) => !prev);
    e.stopPropagation();
  };

  const handleFindingsChange = (newFindings) => {
    setFindings(newFindings);
    // Two-way sync: If Longest RR line is edited in findings, update Longest RR input and call API
    const rrLine = newFindings
      .split('\n')
      .find(line => line.replace(/^#\s*/, '').toLowerCase().startsWith('longest rr interval noted'));
    if (rrLine) {
      // Extract the RR value and time from the findings line
      // Example: "# Longest RR interval noted was 3.2 sec on 2024-01-01 12:34:56"
      const match = rrLine.match(/longest rr interval noted was ([^ ]+) sec on (.+)/i);
      if (match) {
        const rrSec = match[1].trim();
        const rrTime = match[2].trim();
        const newFullValue = `${rrSec} sec @ ${rrTime}`;
        const displayValue = buildLongestRRDisplayValue(newFullValue);
        setFormData(formData => ({
          ...formData,
          maxPause: displayValue,
          maxPauseFull: newFullValue
        }));
        // Call API to update backend
        (async () => {
          try {
            await fetch(`${API_ENDPOINT}/common/update-longest-rr`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ userid: report.userid, longest_rr: newFullValue })
            });
          } catch (error) {
            console.error("❌ Failed to update Longest RR from findings edit:", error);
          }
        })();
      }
    }

    // Two-way sync: If Minimum HR line is edited in findings, update Min HR input
    const minHrLine = newFindings
      .split('\n')
      .find(line => line.replace(/^#\s*/, '').toLowerCase().startsWith('minimum hr was'));
    if (minHrLine) {
      // Example: "# Minimum HR was 30.0 bpm at 17:14:18"
      const match = minHrLine.match(/minimum hr was ([0-9.]+) bpm at ([0-9:]+)/i);
      if (match) {
        const minHrValue = match[1].trim();
        const minHrTime = match[2].trim();
        setFormData(formData => ({
          ...formData,
          minHr: minHrValue,
          minHrTime: minHrTime
        }));

        // Update the correct hour's Min HR in the tableState if available
        if (typeof window.handleTableChange === 'function' && window.tableState && Array.isArray(window.tableState.data)) {
          // Extract hour from minHrTime (e.g., '17:14:18' => 17)
          const hour = parseInt(minHrTime.split(':')[0], 10);
          if (!isNaN(hour)) {
            const updatedData = window.tableState.data.map((row, idx) => {
              // Assuming the hour is the first column in each row
              if (parseInt(row[0], 10) === hour) {
                // Min HR is the 4th column (index 3)
                const newRow = [...row];
                newRow[3] = minHrValue;
                return newRow;
              }
              return row;
            });
            window.handleTableChange({ ...window.tableState, data: updatedData });
          }
        } else if (typeof handleTableChange === 'function') {
          // If handleTableChange is passed as a prop, call it with just the hour and value
          handleTableChange({ hour: minHrTime.split(':')[0], minHr: minHrValue });
        }
      }
    }

    if (onFindingsChange) {
      onFindingsChange(newFindings); // Pass it to the parent (Report.jsx)
    }
  };

  // Handler for input changes
  const onInputChange = (e) => {
    const { name, value } = e.target;

    let updatedData = {
      ...formData,
      [name]: value,
    };

    // Update UI
    setFormData(updatedData);

    // Keep existing save logic
    if (onReportDetailsChange) {
      onReportDetailsChange(updatedData);
    }
  };


  // console.log("formdata!!!!!!!!!!!!", formData);
  let pvc12 = report.pvc[12];
  if (pvc12 && pvc12.includes("@")) {
    // Separate the value and date part at the "@"
    let [pvc12Value, pvc12Date] = pvc12.split("@");

    // Safely extract time (HH:mm:ss) and date (YYYY-MM-DD) if pvc12Date exists
    let formattedTime = pvc12Date
      ? pvc12Date.match(/(\d{2}:\d{2}:\d{2})/)?.[0]
      : "";
    let formattedDate = pvc12Date
      ? pvc12Date
          .match(/(\d{4}-\d{2}-\d{2})/)?.[0]
          .split("-")
          .slice(1)
          .reverse()
          .join("-")
      : "";

    // Combine the value with the formatted time and date
    pvc12 = `${pvc12Value.trim()} ${formattedTime} ${formattedDate}`;

    // console.log("pvc12:", pvc12); // Example: "3 beats(60 bpm) 03:20:12 10-02"
  } else {
    console.error("Invalid format for pvc12 or missing '@'.");
  }

  let pvc13 = report.pvc[13];

  // Check if pvc13 contains an "@" and is not null/undefined
  if (pvc13 && pvc13.includes("@")) {
    // Separate the value and date part at the "@"
    let [pvc13Value, pvc13Date] = pvc13.split("@");

    // Safely extract time (HH:mm:ss) and date (YYYY-MM-DD) if pvc13Date exists
    let formattedTimepvc13 = pvc13Date
      ? pvc13Date.match(/(\d{2}:\d{2}:\d{2})/)?.[0]
      : "";
    let formattedDatepvc13 = pvc13Date
      ? pvc13Date
          .match(/(\d{4}-\d{2}-\d{2})/)?.[0]
          .split("-")
          .slice(1)
          .reverse()
          .join("-")
      : "";

    // Combine the value with the formatted time and date
    pvc13 = `${pvc13Value.trim()} ${formattedTimepvc13} ${formattedDatepvc13}`;

    console.log("pvc13:", pvc13); // Example: "2 beats(70 bpm) 04:30:45 11-03"
  } else {
    console.error("Invalid format for pvc13 or missing '@'.");
  }

  // Output the afib value for debugging
  // console.log("report!!!!!!!!!!!!!!!", report.afib);
  function formatAfibValue(afibData) {
    if (!afibData) {
      return ""; // Handle case when afibData is undefined or null
    }

    // Ensure the string contains " On " to avoid split errors
    const [beatsPart, datePart] = afibData.includes(" On ")
      ? afibData.split(" On ")
      : [afibData, ""];

    // Split the date to get day and month
    const date = datePart
      ? datePart
          .split("-")
          .slice(2)
          .concat(datePart.split("-").slice(1, 2))
          .join("-")
      : ""; // Get dd-mm

    // Format the output
    return `${beatsPart.trim()} ${date}`; // Return "9 beats(61 bpm) @02:13:42 10-02"
  }

  function formatAfibFastestValue(afibData) {
    if (!afibData) {
      return ""; // Handle case when afibData is undefined or null
    }

    // Ensure the string contains " on " to avoid split errors
    const [beatsPart, datePart] = afibData.includes(" on ")
      ? afibData.split(" on ")
      : [afibData, ""];

    // Split the date to get day and month
    const date = datePart
      ? datePart
          .split("-")
          .slice(2)
          .concat(datePart.split("-").slice(1, 2))
          .join("-")
      : ""; // Get dd-mm

    // Format the output
    return `${beatsPart.trim()} ${date}`; // Return "63 bpm (3 beats) @02:13:39 10-02"
  }
  const capitalizeEachWord = (str) => {
    console.log(str);
    // return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  console.log("total count", report.total_beatscount);
  return (
    <div
      className="report__page"
      ref={pageRef}
      style={{ position: "relative" }}
    >
      {/* <img src={Template} alt="" className="report__template" /> */}
      <div className="report__header">
        <img src={Logo} alt="Logo" className="report__header-logo" />

        <div className="report__title">
          <p>Extended Holter</p>
          <p>Study Report</p>
        </div>

        <p className="report__underline-header report__analysis-time">
          Analysis Time
        </p>
      </div>
      <div
        className="report__form-container"
        style={{ left: "20px", top: "67.34px" }}
      >
        {/* FIRST ROW */}
        <div className="report__form-row">
          <Input
            label="Patient Name"
            name="name"
            labelWidth={73}
            inputWidth={161}
            value={formData.name}
            onChange={onInputChange}
          />
          <Input
            label="Gender"
            labelWidth={41}
            inputWidth={62}
            value={formData.gender}
            onChange={onInputChange}
            name="gender"
          />
          <Input
            label="Age"
            labelWidth={14}
            inputWidth={45}
            value={formData.age}
            placeholder="Age"
            name="age"
            onChange={onInputChange}
          />

          {/* <Label label="Day" name="day" labelWidth={50} showSeparator={false} />  */}

          <Label label="Duration" variant="small" labelWidth={33} />
          <Input
            value={formData.duration}
            name="duration"
            inputWidth={120}
            onChange={onInputChange}
          />
        </div>

        {/* SECOND ROW */}
        <div
          className="report__form-row second-row"
          style={{ marginBottom: "0px" }}
        >
          {report.ip_op && report.ip_op !== "NA" ? (
            <Input
              label="MRD No."
              labelWidth={69}
              inputWidth={56}
              value={formData.mrd_no}
              name="ip_op"
              onChange={onInputChange}
            />
          ) : (
            <Input
              label="Patient ID"
              labelWidth={69}
              inputWidth={56}
              value={formData.patientid}
              name="device_id"
              onChange={onInputChange}
            />
          )}

          <Input
            label="Indication"
            labelWidth={45}
            inputWidth={90}
            value={formData.Indication}
            name="Indication"
            onChange={onInputChange}
          />
          <Input
            label="Analysed Beats"
            labelWidth={80}
            inputWidth={56}
            value={formData.beats}
            name="beats"
            onChange={onInputChange}
          />

          <Input
            label="From"
            labelWidth={27}
            inputWidth={125}
            value={formData.from}
            placeholder="From"
            name="from"
            className="from-container"
            onChange={onInputChange}
          />
        </div>
        {/* THIRD ROW */}
        <div className="report__form-row">
          <Input
            label="Organization"
            labelWidth={73}
            inputWidth={191}
            value={formData.organization}
            name="Organization"
            onChange={onInputChange}
            // Make the label bold
          />

          <label
            style={{
              fontSize: "11.1px",
              fontFamily: "Times, serif",
              color: "#000",
              marginLeft: "6px",
            }}
          >
            Pacemaker:
          </label>
          <select
            name="pacemaker"
            onChange={onInputChange}
            value={formData.pacemaker}
            style={{
              border: "none",
              outline: "none",
              background: "white",
              appearance: "none",
              WebkitAppearance: "none",
              MozAppearance: "none",
              fontSize: "11.1px", // Set font size
              fontFamily: "Times, serif", // Set font family
              padding: "5px 8px", // Adjust padding
              borderRadius: "4px",
              cursor: "pointer",
              width: "80px", // Adjust width to prevent too much expansion
              textAlign: "center",
              color: "rgb(55, 52, 53)",
              marginBottom: "-5px",
              width: "95px",
            }}
          >
            <option
              value="true"
              style={{ fontSize: "11.1px", fontFamily: "Times, serif" }}
            >
              Yes
            </option>
            <option
              value="false"
              style={{ fontSize: "11.1px", fontFamily: "Times, serif" }}
            >
              No
            </option>
          </select>
          <Input
            label="To"
            labelWidth={45}
            inputWidth={110}
            value={formData.to}
            name="to"
            placeholder="To"
            onChange={onInputChange}
          />

          {/* <Input
            label="BMI"
            labelWidth={30}
            inputWidth={50}
            value={parseInt(report.weight/((report.height/100)*(report.height/100)))}
            name="bmi"
          /> */}

          {/* <Input
            label="CHA2DS2-VASc Score"
            labelWidth={120}
            inputWidth={100}
            value={report.CHA2Vasc_Score}
            name="CHA2Vasc"
            placeholder="0"
          /> */}
        </div>
        {/* FOURTH ROW */}
        <div className="report__form-row">
          <div
            style={{
              marginLeft: "280px",
              marginTop: "-5px",
              fontSize: "11.1px",
              fontFamily: "Times, serif",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <Input
                label="Referred By"
                labelWidth={64}
                inputWidth={146}
                value={formData.referredBy}
                name="doctorName"
                onChange={onInputChange}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="report__mid-form-container report__mid-form-container--1">
        <div className="report__mid-form-header">
          <p>ATRIAL ECTOPICS</p>
        </div>

        <div className="report__mid-form">
          <Input
            label="Total"
            labelFontFamily="Bookman Old Style"
            labelWidth={70}
            inputWidth={140}
            value={formData.atrial_ectopicsTotal}
            name="atrial_ectopicsTotal"
            onChange={onInputChange}
          />
          <Input
            label="Isolated"
            labelFontFamily="Bookman Old Style"
            labelWidth={70}
            inputWidth={100}
            value={formData.atrial_ectopicsIsolated}
            name="atrial_ectopicsIsolated"
            onChange={onInputChange}
          />
          <Input
            label="Couplet"
            labelFontFamily="Bookman Old Style"
            labelWidth={70}
            inputWidth={100}
            value={formData.atrial_ectopicsCouplet}
            name="atrial_ectopicsCouplet"
            onChange={onInputChange}
          />
          <Input
            label="Triplet"
            labelFontFamily="Bookman Old Style"
            labelWidth={70}
            inputWidth={100}
            value={formData.atrial_ectopicsTriplet}
            name="atrial_ectopicsTriplet"
            onChange={onInputChange}
          />
          <Input
            label="Longest"
            labelFontFamily="Bookman Old Style"
            labelWidth={70}
            inputWidth={178}
            value={formData.atrial_ectopicsLongest}
            name="atrial_ectopicsLongest"
            onChange={onInputChange}
          />
          <Input
            label="Fastest"
            labelFontFamily="Bookman Old Style"
            labelWidth={70}
            inputWidth={178}
            value={formData.atrial_ectopicsFastest}
            name="atrial_ectopicsFastest"
            onChange={onInputChange}
          />
          <Input
            label="Trigeminy"
            labelFontFamily="Bookman Old Style"
            labelWidth={70}
            inputWidth={126}
            value={formData.atrial_ectopicsTrigeminy}
            name="atrial_ectopicsTrigeminy"
            onChange={onInputChange}
          />
          <Input
            label="Bigeminy"
            labelFontFamily="Bookman Old Style"
            labelWidth={70}
            inputWidth={126}
            value={formData.atrial_ectopicsBigeminy}
            name="atrial_ectopicsBigeminy"
            onChange={onInputChange}
          />
        </div>
      </div>

      <div className="report__mid-form-container report__mid-form-container--2">
        <div className="report__mid-form-header">
          <p>VENTRICULAR ECTOPICS</p>
        </div>

        <div className="report__mid-form">
          <Input
            label="Total"
            labelFontFamily="Bookman Old Style"
            labelWidth={72}
            inputWidth={126}
            value={formData.ventricular_ectopicsTotal}
            name="ventricular_ectopicsTotal"
            onChange={onInputChange}
          />
          <Input
            label="Isolated"
            labelFontFamily="Bookman Old Style"
            labelWidth={72}
            inputWidth={126}
            value={formData.ventricular_ectopicsIsolated}
            name="ventricular_ectopicsIsolated"
            onChange={onInputChange}
          />
          <Input
            label="Couplet"
            labelFontFamily="Bookman Old Style"
            labelWidth={72}
            inputWidth={126}
            value={formData.ventricular_ectopicsCouplet}
            name="ventricular_ectopicsCouplet"
            onChange={onInputChange}
          />
          <Input
            label="Triplet"
            labelFontFamily="Bookman Old Style"
            labelWidth={72}
            inputWidth={126}
            value={formData.ventricular_ectopicsTriplet}
            name="ventricular_ectopicsTriplet"
            onChange={onInputChange}
          />
          <Input
            label="Longest"
            labelFontFamily="Bookman Old Style"
            labelWidth={72}
            inputWidth={181}
            value={formData.ventricular_ectopicsLongest}
            name="ventricular_ectopicsLongest"
            onChange={onInputChange}
          />

          <Input
            label="Fastest"
            labelFontFamily="Bookman Old Style"
            labelWidth={72}
            inputWidth={181}
            value={formData.ventricular_ectopicsFastest}
            name="ventricular_ectopicsFastest"
            onChange={onInputChange}
          />

          <Input
            label="Trigeminy"
            labelFontFamily="Bookman Old Style"
            labelWidth={72}
            inputWidth={140}
            value={formData.ventricular_ectopicsTrigeminy}
            name="ventricular_ectopicsTrigeminy"
            onChange={onInputChange}
          />

          <Input
            label="Bigeminy"
            labelFontFamily="Bookman Old Style"
            labelWidth={72}
            inputWidth={140}
            value={formData.ventricular_ectopicsBigeminy}
            name="ventricular_ectopicsBigeminy"
            onChange={onInputChange}
          />
          <Input
            label="Episodes"
            labelFontFamily="Bookman Old Style"
            labelWidth={72}
            inputWidth={140}
            value={formData.ventricular_ectopicsEpisodes}
            name="ventricular_ectopicsEpisodes"
            onChange={onInputChange}
          />
        </div>
      </div>

      <div className="report__mid-form-container report__mid-form-container--3">
        <div className="report__mid-form-header">
          <p>PAUSES</p>
        </div>

        <div className="report__mid-form">
          <Input
            label="Pauses in excess of 2 Sec"
            labelFontFamily="Bookman Old Style"
            labelWidth={170}
            inputWidth={40}
            value={`${formData.pausesIntwosec}`}
            name="pausesIntwosec"
            onChange={onInputChange}
          />
          <Input
            label="Pauses in excess of 2.5 Sec"
            labelFontFamily="Bookman Old Style"
            labelWidth={201}
            inputWidth={189}
            value={
              formData.pausesInExcess.includes("[pauses in excess 3 sec:")
                ? formData.pausesInExcess
                : `${formData.pausesInExcess}` +
                  ((report["sinus pause 3 sec"] && report.sinus_pause !== "7")
                    ? ` [pauses in excess 3 sec: ${report["sinus pause 3 sec"]}]`
                    : "")
            }
            name="pausesInExcess"
            onChange={onInputChange}
          />

        {/* 🔽 Longest RR Dropdown (plain text style) */}
        <div style={{ display: "flex", alignItems: "center",marginTop:"-2%",width:"113%" }}>
          <label
            style={{
              width: 105,
              fontFamily: "Bookman Old Style",
              fontSize: "11px",
              marginRight: 8
            }}
          >
            Longest RR
          </label>

          <div style={{ position: "relative", width: "250px" ,border:"none"}}>
            <input
              type="text"
              name="maxPause"
              value={formData.maxPause || ""}
              className="plain-select"
              onChange={async (e) => {
                const value = e.target.value;
                const displayValue = buildLongestRRDisplayValue(value);

                setFormData(prev => ({
                  ...prev,
                  maxPause: displayValue,
                  maxPauseFull: value
                }));

                // Always update findings with displayValue (formatted seconds and time)
                updateFindingsWithLongestRR(displayValue);

                try {
                  const response = await fetch(`${API_ENDPOINT}/common/update-longest-rr`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                      userid: report.userid,
                      longest_rr: value
                    })
                  });

                  const data = await response.json();
                  console.log("✅ Sinus pause updated:", data);
                } catch (error) {
                  console.error("❌ Failed to update Longest RR:", error);
                }

                if (onReportDetailsChange) {
                  onReportDetailsChange({
                    ...formData,
                    maxPause: displayValue,
                    maxPauseFull: value,
                    sinus_pause: value
                  });
                }
              }}
              onFocus={() => {
                setFormData(prev => ({
                  ...prev,
                  showDropdown: true
                }));
              }}
              style={{
                padding: "5px 8px",
                fontSize: "11.1px",
                fontFamily: "Times, serif",
                border: "none",
                borderRadius: "4px",
                width: "100%",
                boxSizing: "border-box"
              }}
              placeholder="Select or type value"
            />

            {formData.showDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  borderTop: "none",
                  borderRadius: "0 0 4px 4px",
                  maxHeight: "200px",
                  overflowY: "auto",
                  zIndex: 1000,
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)"
                }}
              >
                {formData.longest_rr?.map((item, index) => {
                  const optionFullValue = buildLongestRRFullValueFromItem(item);
                  const optionDisplayValue = buildLongestRRDisplayValue(optionFullValue);
                  const optionLabel = buildLongestRROptionLabel(item);
                  return (
                    <div
                      key={index}
                      onClick={async () => {

                        setFormData(prev => ({
                          ...prev,
                          maxPause: optionDisplayValue,
                          maxPauseFull: optionFullValue,
                          showDropdown: false
                        }));

                        // Update findings with full value (includes date and time)
                        updateFindingsWithLongestRR(optionFullValue);

                        try {
                          const response = await fetch(`${API_ENDPOINT}/common/update-longest-rr`, {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                              userid: report.userid,
                              longest_rr: optionFullValue
                            })
                          });

                          const data = await response.json();
                          console.log("✅ Sinus pause updated:", data);
                        } catch (error) {
                          console.error("❌ Failed to update Longest RR:", error);
                        }

                        if (onReportDetailsChange) {
                          onReportDetailsChange({
                            ...formData,
                            maxPause: optionDisplayValue,
                            maxPauseFull: optionFullValue,
                            sinus_pause: optionFullValue
                          });
                        }
                      }}
                      style={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        backgroundColor: formData.maxPause === optionDisplayValue ? "#e0e0e0" : "white",
                        borderBottom: "1px solid #f0f0f0",
                        fontSize: "11.1px",
                        fontFamily: "Times, serif"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#f5f5f5";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = formData.maxPause === optionDisplayValue ? "#e0e0e0" : "white";
                      }}
                    >
                      {optionLabel}
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {formData.showDropdown && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 999
              }}
              onClick={() => {
                setFormData(prev => ({
                  ...prev,
                  showDropdown: false
                }));
              }}
            />
          )}


        </div>


        </div>
      </div>


      {/* <div className="report__mid-form-container report__mid-form-container--4">
        <div className="report__mid-form-header">
          <p>
            HEART RATE
            <span
              style={{
                fontSize: "9.5px",
                fontFamily: "Bookman Old Style",
                paddingLeft: "2px",
              }}
            >
              [4 RR Interval]
            </span>
          </p>
        </div>

        <div className="report__mid-form">
          <Input
            label="Maximum HR"
            labelFontFamily="Bookman Old Style"
            labelWidth={105}
            inputWidth={100}
            value={report.max_hr}
            name="max_hr"
          />
          <Input
            label="Minimum HR"
            labelFontFamily="Bookman Old Style"
            labelWidth={105}
            inputWidth={100}
            value={report.min_hr}
            name="min_hr"
          />
          <Input
            label="Average HR"
            labelFontFamily="Bookman Old Style"
            labelWidth={105}
            inputWidth={100}
            value={report.avg_heartrate}
            name="avg_heartrate"
          />
        </div>
      </div> */}
      <div className="report__mid-form-container report__mid-form-container--5">
        <div className="report__mid-form-header">
          <p>Afib / Flutter</p>
        </div>
        <div className="report__mid-form">
          {report.afib[0] === "0|0%" ? (
            <p className="afib-container">No AFIB Noted</p>
          ) : (
            <Input
              label="Burden"
              labelFontFamily="Bookman Old Style"
              labelWidth={65}
              inputWidth={140}
              value={formData.afibBurden}
              name="afibBurden"
              onChange={onInputChange}
            />
          )}
          {report.afib[4] != 0 && (
            <Input
              label="Longest"
              labelFontFamily="Bookman Old Style"
              labelWidth={70}
              inputWidth={193}
              value={formatAfibValue(formData.afibLongest)}
              name="afibLongest"
              onChange={onInputChange}
            />
          )}
          {report.afib[4] != 0 && (
            <Input
              label="Fastest"
              labelFontFamily="Bookman Old Style"
              labelWidth={70}
              inputWidth={193}
              value={formatAfibFastestValue(formData.afibFastest)}
              name="afibFastest"
              onChange={onInputChange}
            />
          )}
        </div>
      </div>

      <div className="report__images">
        {/* Show only the first two images by user-defined priority */}
        {(() => {
          let priority = [];
          try {
            const saved = localStorage.getItem("report_priority_first_page");
            if (saved) priority = JSON.parse(saved);
          } catch (e) {}
          const orderMap = new Map(priority.map((p, i) => [p.key, i]));
          const sortedImages = [...report.images].sort((a, b) => {
            const indexA = orderMap.has(a.key) ? orderMap.get(a.key) : Infinity;
            const indexB = orderMap.has(b.key) ? orderMap.get(b.key) : Infinity;
            return indexA - indexB;
          });
          return sortedImages.slice(0, 2).map((image) => (
            <div className="report__imageContainer" key={image.key}>
              <input className="report__image-title" defaultValue={image.name} />
              <img
                className="report__image"
                src={`${ROOT_URI}/${formData.patientid}/${image.key}/cropped_image/max_${image.key}.png`}
                alt=""
              />
            </div>
          ));
        })()}
      </div>

      <img
        className="report__pie-chart"
        src={`${ROOT_URI}/${formData.patientid}/main_pie_chart.png`}
        alt="PIE CHART"
      />

      <div className="report__findingsninterpretation">
        <div className="report__findings">
          <p className="header">FINDINGS</p>
          <div style={{ flex: 1 }}>
            <DynamicTextArea
              value={findings || report.findings}
              onChange={handleFindingsChange}
              signatureEnabled={formData.organization.trim().toUpperCase() !== "SCTIMST" && signatureEnabled}
              signatureUrl={signatureUrl}
            />
          </div>
        </div>
      </div>
      {/* Draggable and rotatable signature image, only if organization is not SCTIMST */}
      {signatureUrl && formData.organization.trim().toUpperCase() !== "SCTIMST" && (
        <>
          <img
            src={
              typeof signatureUrl === "string"
                ? signatureUrl
                : URL.createObjectURL(signatureUrl)
            }
            alt="Signature"
            style={{
              position: "absolute",
              left: sigPos.x,
              top: sigPos.y,
              maxWidth: "180px",
              maxHeight: "90px",
              border: "none",
              background: "none",
              padding: "2px",
              cursor: dragging ? "grabbing" : "grab",
              zIndex: 1000,
              userSelect: "none",
              opacity: 0.6,
              pointerEvents: "auto",
              transform: `rotate(${rotation}deg)`,
            }}
            onMouseDown={handleMouseDown}
            onClick={handleSignatureClick}
            draggable={false}
          />
          {/* Rotate button, positioned near the signature */}
          {showRotate && !dragging && (
            <button
              type="button"
              onClick={handleRotateSignature}
              style={{
                position: "absolute",
                left: sigPos.x + 150,
                top: sigPos.y + 70,
                zIndex: 1001,
                background: "#fff",
                border: "1px solid #aaa",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                cursor: "pointer",
                boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                fontSize: "18px",
              }}
            >
              {"\u21BB"}
            </button>
          )}
        </>
      )}
      <ReportFooter page="1" totalPage={totalPages} />
    </div>
  );
};

export default FirstPage;